/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

class PaginationNavigation extends Component {
  render() {
    const getFromItem = () => {
      if (this.props.fixCount !== null) {
        return this.props.fixCount;
      } else if (this.props.paginationData !== null) {
        if (this.props.paginationData.totalCount === 0) {
          return 0;
        }
        return (
          this.props.paginationData.currentPage *
            this.props.paginationData.perPage -
          this.props.paginationData.perPage +
          1
        );
      }
      return 0;
    };

    const getToItem = () => {
      if (this.props.fixCount !== null) {
        return this.props.fixCount;
      } else if (this.props.paginationData !== null) {
        if (
          this.props.paginationData.currentPage *
            this.props.paginationData.perPage >
          this.props.paginationData.totalCount
        ) {
          return this.props.paginationData.totalCount;
        }
        return (
          this.props.paginationData.currentPage *
          this.props.paginationData.perPage
        );
      }
      return 0;
    };

    const getTotalCount = () => {
      if (this.props.fixCount !== null) {
        return this.props.fixCount;
      } else if (this.props.paginationData !== null) {
        return this.props.paginationData.totalCount;
      }
      return 0;
    };

    return (
      <React.Fragment>
        {t('Записи с {from} по {to} из {total}', {
          from: getFromItem(),
          to: getToItem(),
          total: getTotalCount()
        })}
      </React.Fragment>
    );
  }
}

PaginationNavigation.defaultProps = {
  paginationData: null,
  fixCount: null
};

PaginationNavigation.propTypes = {
  paginationData: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }),
  fixCount: PropTypes.number
};

export default PaginationNavigation;



// WEBPACK FOOTER //
// ./src/components/Common/Pagination/PaginationPageInfo.js